import React from "react";
import { useTranslation } from "react-i18next";
import { Col, Pagination, Row } from "react-bootstrap";
import { ChevronLeft, ChevronRight } from "lucide-react";

const Paginations = ({ currentPage, totalPages, onPageChange, totalCount }) => {
  const { t } = useTranslation();

  const handleClickPrevious = () => {
    onPageChange(Math.max(currentPage - 1, 1)); // Update data for previous page
  };

  const handleClickNext = () => {
    onPageChange(Math.min(currentPage + 1, totalPages)); // Update data for next page
  };

  const handleClickPage = (page) => {
    onPageChange(page); // Update data for selected page
  };

  // Function to generate page numbers with ellipsis
  const generatePageNumbers = () => {
    const pageNumbers = [];
    const range = 2; // Number of page numbers to show before and after the current page
    let start = Math.max(1, currentPage - range);
    let end = Math.min(totalPages, currentPage + range);

    // Add ellipsis and first page if currentPage is not at the beginning
    if (currentPage > range + 1) {
      pageNumbers.push(
        <Pagination.Item key={1} onClick={() => handleClickPage(1)}>
          {1}
        </Pagination.Item>
      );
    }

    // Generate page numbers around the current page
    for (let i = start; i <= end; i++) {
      pageNumbers.push(
        <Pagination.Item
          key={i}
          active={currentPage === i}
          disabled={currentPage === i}
          onClick={() => handleClickPage(i)}
        >
          {i}
        </Pagination.Item>
      );
    }

    // Add ellipsis and last page if currentPage is not at the end
    if (currentPage < totalPages - range) {
      pageNumbers.push(
        <Pagination.Item key="ellipsis-end" disabled>
          ...
        </Pagination.Item>
      );
      pageNumbers.push(
        <Pagination.Item
          key={totalPages}
          nClick={() => handleClickPage(totalPages)}
        >
          {totalPages}
        </Pagination.Item>
      );
    }

    return pageNumbers;
  };

  return (
    <>
      {totalCount > 0 ? (
        <Row className="custom_pagination my-4">
          <Col sm={12}>
            <div className={"paginationWrapper g_between"}>
              <ul className={"pagination"}>
                <li
                  className={`paginate_button page-item previous ${
                    currentPage === 1 ? "disabled" : ""
                  }`}
                >
                  <button
                    className="transparent_btn mt-1"
                    onClick={handleClickPrevious}
                    disabled={currentPage === 1}
                  >
                    <ChevronLeft />
                  </button>
                </li>
                {generatePageNumbers()}
                <li
                  className={`paginate_button ${
                    currentPage === totalPages ? "disabled" : ""
                  }`}
                >
                  <button
                    className="transparent_btn mt-1"
                    onClick={handleClickNext}
                    disabled={currentPage === totalPages || !totalPages}
                  >
                    <ChevronRight />
                  </button>
                </li>
              </ul>
              <h2 className="fs_14 text_dark_gray">
                {t("Total Records")} {totalCount}
              </h2>
            </div>
          </Col>
        </Row>
      ) : null}
    </>
  );
};

export default Paginations;
